import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  loading: false,
  updateBtnLoading: false,
  stockOutProducts: null,
  expiredProducts: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STOCK_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
